import React, { useState, useRef, useEffect } from 'react';
import './MultiSelect.css';

const MultiSelect = ({ 
  options = [], 
  value = [], 
  onChange, 
  placeholder = "Select options...",
  className = "",
  disabled = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = options.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionToggle = (optionId) => {
    const newValue = value.includes(optionId)
      ? value.filter(id => id !== optionId)
      : [...value, optionId];
    onChange(newValue);
  };

  const getSelectedNames = () => {
    return value.map(id => {
      const option = options.find(opt => opt.id === id);
      return option ? option.name : '';
    }).filter(name => name).join(', ');
  };

  return (
    <div className={`position-relative ${className}`} ref={dropdownRef}>
      <div
        className={`form-control d-flex justify-content-between align-items-center ${disabled ? 'disabled' : ''}`}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer', minHeight: '38px' }}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span className={value.length === 0 ? 'text-muted' : ''}>
          {value.length === 0 ? placeholder : getSelectedNames()}
        </span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
      </div>

      {isOpen && !disabled && (
        <div 
          className="position-absolute w-100 bg-white border rounded shadow-sm"
          style={{ zIndex: 1050, maxHeight: '200px', overflowY: 'auto', top: '100%' }}
        >
          <div className="p-2 border-bottom">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          
          <div className="py-1">
            {filteredOptions.length === 0 ? (
              <div className="px-3 py-2 text-muted">No options found</div>
            ) : (
              filteredOptions.map(option => (
                <div
                  key={option.id}
                  className={`px-3 py-2 d-flex align-items-center multiselect-option ${
                    value.includes(option.id) ? 'selected' : ''
                  }`}
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOptionToggle(option.id);
                  }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={value.includes(option.id)}
                    onChange={() => {}}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <span>{option.name}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelect;